import { zonedTimeToUtc } from 'date-fns-tz';
import { TZ } from './date';

export const TOTAL_BOOKING_REQUESTS_POLL_INTERVAL = 60 * 1000;

export const localMinTime = zonedTimeToUtc(new Date().setHours(9, 0, 0, 0), TZ);
export const localMaxTime = zonedTimeToUtc(new Date().setHours(18, 0, 0, 0), TZ);
